import React from "react";
import PropTypes from "prop-types";
import AppFormContext from "components/common/AppFormContext";
import { formatFormulaLabel } from "utils/formula";

const formatDate = (value) => {
  if (!value) return "Sin fecha";
  const date = /^\d{4}-\d{2}-\d{2}$/.test(String(value))
    ? new Date(`${value}T12:00:00`)
    : new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin fecha";
  return date.toLocaleDateString("es-UY", { timeZone: "America/Montevideo" });
};

const formatCounterFormula = (formula) => formatFormulaLabel(formula, { fallback: "$" });

function InitialValuesMachineSummary({ localMachine, startDateTime, counterConfig }) {
  const type =
    localMachine?.MachineType?.Type ??
    (typeof localMachine?.MachineType === "string" ? localMachine.MachineType : null) ??
    localMachine?.Machine?.MachineType?.Type ??
    localMachine?.MachineTypeType ??
    "Máquina";
  const name = localMachine?.Machine?.Name ?? localMachine?.MachineName ?? "Sin nombre";
  const formulaSource = localMachine?.Formula ?? localMachine?.Machine?.Formula ?? localMachine;
  const rawFormula = formatFormulaLabel(formulaSource, { fallback: "" });
  const formula = rawFormula && !/^sin f[oó]rmula$/i.test(rawFormula) ? rawFormula : "$";
  const accumulation = localMachine?.IsAccumulative;
  const hasReset = accumulation === false || accumulation === 0 || accumulation === "0";

  const inFormula = counterConfig?.CounterInFormula;
  const outFormula = counterConfig?.CounterOutFormula;
  const sharedCounterFormula = formatCounterFormula(inFormula) === formatCounterFormula(outFormula);
  const lines = [
    `${hasReset ? "borrado " : ""}${formula}`,
    `Fecha de ingreso al local: ${formatDate(startDateTime ?? localMachine?.StartDateTime)}`,
  ];

  if (counterConfig) {
    if (sharedCounterFormula) {
      lines.push(`Fórmula de contadores: ${formatCounterFormula(inFormula)}`);
    } else {
      lines.push(`Fórmula contador entrada: ${formatCounterFormula(inFormula)}`);
      lines.push(`Fórmula contador salida: ${formatCounterFormula(outFormula)}`);
    }
    lines.push(
      `Tolerancia: ${counterConfig.ToleranceAmount == null ? "—" : `$ ${counterConfig.ToleranceAmount}`}`
    );
  }

  return <AppFormContext title={`${type} ${name}`} lines={lines} />;
}

InitialValuesMachineSummary.propTypes = {
  localMachine: PropTypes.object.isRequired,
  startDateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  counterConfig: PropTypes.object,
};

export default InitialValuesMachineSummary;
